import update from 'immutability-helper';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import cloneDeep from 'lodash/cloneDeep';

update.extend('$deepMerge',(changes,original) => merge(cloneDeep(original),changes));
update.extend('$delete',(changes,original) => omit(cloneDeep(original),changes));
update.extend('$without',(changes,original) => cloneDeep(original));

export default update;



// WEBPACK FOOTER //
// ./src/shared/redux/update.js